import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Logo from "../utils/topline_logo.png";
import {
  Building2,
  ChevronDown,
  Eye,
  EyeOff,
  Mail,
  MapPin,
  Phone,
  Settings,
  Shield,
  Users,
  Zap,
} from "lucide-react";

const LoginPage = () => {
  let company_code_from_local_storage = localStorage.getItem("companyCode")
    ? localStorage.getItem("companyCode")
    : "-";
  

  const [selectedCompany, setSelectedCompany] = useState(null);
  const [isFetchingCompanies, setIsFetchingCompanies] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [loginUserName, setLoginUserName] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState(""); // Error state
  console.log("loginUserName:", loginUserName);
  console.log("password:", password);
  const navigate = useNavigate();

  const MASTER_COMPANY_CODE = localStorage?.getItem("masterCompanyCode") || "-";

  const checkIfAlreadyLoggedIn = () => {
    let token = false;

    const loginStatus = localStorage.getItem("currentUserLoginStatus");

    if (loginStatus) {
      if (JSON.parse(loginStatus)) {
        token = true;
      }
    }

    if (token) {
      navigate("/home");
    }
  };

  // old way
  // const getApiPaths = async () => {
  //   let result = new Promise((resolve) => {
  //     axios
  //       .get(
  //         `https://cubixweberp.com:301/api/clientmanager/${company_code_from_local_storage}`
  //       )
  //       .then((res) => {
  //         if (res.data?.length > 0) {
  //           localStorage.setItem("apiPaths", JSON.stringify(res.data));
  //           resolve(true);
  //         } else {
  //           localStorage.setItem("apiPaths", JSON.stringify([]));
  //           resolve(false);
  //         }
  //       })
  //       .catch((err) => {
  //         resolve(false);
  //       });
  //   });

  //   let returnResultOfAPIPath = await result;
  //   return returnResultOfAPIPath;
  // };

  // athu's way 
  const getApiPaths = async (companyCode) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}:213/api/clientSingle/${companyCode}`,
      );

      if (response.data?.length > 0) {
        localStorage.setItem("apiPaths", JSON.stringify(response.data));
        return response.data;
      } else {
        localStorage.setItem("apiPaths", JSON.stringify([]));
        return null;
      }
    } catch (err) {
      console.error("Failed to fetch API paths:", err);
      return null;
    }
  };

  const getSubCompanies = async () => {
    if (!MASTER_COMPANY_CODE) return;
    const previousCompanyCode = localStorage.getItem("companyCode");
    setIsFetchingCompanies(true);
    try {
      // Use a default base URL for initial company fetch
      const defaultBaseUrl = "https://cubixweberp.com:213";
      const response = await axios.get(
        `${defaultBaseUrl}/api/companylist/${MASTER_COMPANY_CODE}`
      );
      if (response.data && response.data.length > 0) {
        setCompanies(response.data);
        setSelectedCompany(
          previousCompanyCode
            ? response.data?.find(
                (company) => company?.COMPID === previousCompanyCode
              )
            : response.data[0]
        );
      }
    } catch (err) {
      console.error("Failed to fetch companies", err);
    } finally {
      setIsFetchingCompanies(false);
    }
  };

  

  useEffect(() => {
   

    checkIfAlreadyLoggedIn();

    getSubCompanies();
  }, []);

  
  const handleLogin = async (e) => {
    e.preventDefault(); // Prevent form from refreshing

    const targetCompanyCode = selectedCompany?.COMPID || MASTER_COMPANY_CODE;

    try {

      // Step 1: Fetch API paths for the selected company
      console.log("Fetching API paths for company:", targetCompanyCode);
      const apiPaths = await getApiPaths(targetCompanyCode);


      const BASE_URL = apiPaths[0].API_CONFIG || "https://cubixweberp.com:213";
      console.log("Base URL:", BASE_URL);

      const apiurl = `${BASE_URL}/api/LoginUser?user=${loginUserName}&pass=${password}&cmpcode=${company_code_from_local_storage}`;

      console.log("apiurl login >>>", apiurl);
      const response = await axios.get(apiurl);

      const loginData = response.data;
      console.log("Success! loginData:", loginData);

      const successUser = loginData.find((user) => user.Userlogin === "Sucess");
      const userEmployeeID = loginData[0]?.EMPID;
      const userFirstDeptNo = loginData[0]?.DEPTNO;

      console.log("Success! loginDept:", userFirstDeptNo);

      if (successUser) {
        if (userFirstDeptNo && userFirstDeptNo.trim() !== "") {
          localStorage.setItem("companyCode", targetCompanyCode);
          localStorage.setItem("currentUser", JSON.stringify(loginData));
          localStorage.setItem("currentUserName", loginUserName?.trim());
          localStorage.setItem("currentUserEmployeeID", userEmployeeID?.trim());
          localStorage.setItem(
            "currentSelectedDepartment",
            userFirstDeptNo?.trim()
          );
          localStorage.setItem("currentUserLoginStatus", JSON.stringify(true));

          navigate("/home"); // Navigate to the homepage on successful login
        } else {
          // Show snackbar if DEPTNO is missing
          setErrorMessage(
            "Department number is missing. Please contact admin."
          );
        }
      } else {
        setErrorMessage("Invalid credentials. Please try again.");
      }
    } catch (error) {
      console.error("Error while logging in:", error);
      setErrorMessage("Login failed. Please check your credentials.");
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen z-30">
      {/* <img src={Logo} alt="salesdood-logo" className="w-120 h-108 mx-auto mb-4" /> */}
      <div className="w-full max-w-md p-8 bg-white  rounded-lg shadow-lg">
        <img
          src={Logo}
          alt="salesdood-logo"
          className="w-120 h-8 mx-auto mb-4"
        />
        <h2 className="text-2xl font-bold text-center text-gray-700">Login</h2>

        {errorMessage && (
          <p className="text-red-500 text-sm text-center mt-2">
            {errorMessage}
          </p>
        )}

        <form onSubmit={handleLogin} className="mt-6">
          {companies && companies?.length > 0 && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">
                Select Company *
              </label>
              <div className="relative group">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Building2 className="h-4 w-4 text-gray-400 group-focus-within:text-indigo-500 transition-colors" />
                </div>
                <select
                  value={selectedCompany?.COMPID || ""}
                  onChange={(e) => {
                    const comp = companies.find(
                      (c) => c.COMPID === e.target.value
                    );
                    setSelectedCompany(comp);
                  }}
                  className="block w-full pl-10 pr-10 py-3 text-sm border border-gray-300 rounded-lg appearance-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white outline-none transition-all cursor-pointer"
                  disabled={isFetchingCompanies}
                >
                  {isFetchingCompanies ? (
                    <option>Loading companies...</option>
                  ) : (
                    companies.map((comp) => (
                      <option key={comp.COMPID} value={comp.COMPID}>
                        {comp.COMPNAME}

                        {/* {comp.COMPID} - {comp.COMPNAME} */}
                      </option>
                    ))
                  )}
                </select>
                {/* <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                    <ChevronDown className="h-4 w-4 text-gray-400" />
                  </div> */}
              </div>
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Username
            </label>
            <input
              type="text"
              className="w-full px-4 py-2 mt-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
              placeholder="Enter your username"
              value={loginUserName}
              onChange={(e) => setLoginUserName(e.target.value)}
              required
            />
          </div>

          <div className="mt-4">
            <label className="block text-sm font-medium text-gray-700">
              Password
            </label>
            <input
              type="password"
              className="w-full px-4 py-2 mt-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div className="flex justify-between items-center mt-4">
            <button
              type="button"
              className="text-sm text-blue-600 hover:underline"
            >
              Forgot Password?
            </button>
          </div>

          <button
            type="submit"
            className="w-full mt-6 py-2 text-white bg-blue-500 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
          >
            Login
          </button>
        </form>

        {/* <p className="mt-4 text-sm text-center">
          Don't have an account?{" "}
          <button type="button" className="text-blue-600 hover:underline">
            Sign up
          </button>
        </p> */}
      </div>
    </div>
  );
};

export default LoginPage;
